import {createSlice} from '@reduxjs/toolkit';
import {
    getRecentlyViewedAccountsSuccess,
} from 'src/openapi/admin/apis/GetRecentlyViewedAccountsApi';
import {
    getRecentlyViewedUsersSuccess,
} from 'src/openapi/admin/apis/GetRecentlyViewedUsersApi';

import type {AccountShortInfo} from 'src/openapi/admin/models/AccountShortInfo';
import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';
import type {AppState} from 'src/store/typedef';

type InitialState = {
    accounts: Array<AccountShortInfo>,
    users: Array<UserShortInfo>,
};

export const initialState: InitialState = {
    accounts: [],
    users: [],
};

export const recentlyViewedSlice = createSlice({
    name: 'recentlyViewed',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getRecentlyViewedAccountsSuccess, (state, action) => {
                state.accounts = action.payload.data;
            })
            .addCase(getRecentlyViewedUsersSuccess, (state, action) => {
                state.users = action.payload.data;
            });
    },
});

export const selectRecentlyViewedAccounts: (state: AppState) => Array<AccountShortInfo> = state =>
    state.recentlyViewed.accounts;

export const selectRecentlyViewedUsers: (state: AppState) => Array<UserShortInfo> = state =>
    state.recentlyViewed.users;
